import React, { useRef } from 'react';
import Modal from 'react-modal';
import './Modal.css'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from 'moment-timezone';

// import moment from 'moment';
// Type definition for the modal's props
interface IAgreementModalProps {
  isOpen: boolean;
  onConfirm: (pdfBlob: any) => void;
  onDecline: () => void;
  onRequestClose: () => void;
  details: any
}

// Modal component
const AgreementModal: React.FC<IAgreementModalProps> = ({ isOpen, onConfirm, onDecline, onRequestClose, details }) => {
  console.log("details for agrrement", details)
  const contentRef = useRef<HTMLDivElement>(null);
  // const generatePDF = () => {
  //   const input = document.getElementById('pdf-content');

  //   if (input) {
  //     html2canvas(input)
  //       .then((canvas) => {
  //         const imgData = canvas.toDataURL('image/png');
  //         const pdf = new jsPDF('p', 'mm', 'a4');
  //         const imgWidth = 210;
  //         const pageHeight = 295;
  //         const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //         let heightLeft = imgHeight;
  //         let position = 0;

  //         pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  //         heightLeft -= pageHeight;

  //         while (heightLeft >= 0) {
  //           position = heightLeft - imgHeight;
  //           pdf.addPage();
  //           pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  //           heightLeft -= pageHeight;
  //         }

  //         pdf.save('download.pdf');
  //       })
  //       .catch((error) => {
  //         console.error('Error generating PDF: ', error);
  //       });
  //   }
  // };

  const generatePDF = async () => {
  if (!contentRef.current) {
    return;
  }

  const content = contentRef.current;

  const canvas = await html2canvas(content, {
    scale: 2,
    useCORS: true,
  });

  const imgData = canvas.toDataURL("image/jpeg", 0.9);

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "pt",
    format: "a4",
  });

  // A4 size in points
  const pageWidth = pdf.internal.pageSize.getWidth();   // 595
  const pageHeight = pdf.internal.pageSize.getHeight(); // 842

  // Margins
  const margin = {
    top: 40,
    bottom: 40,
    left: 40,
    right: 40,
  };

  const usableWidth = pageWidth - margin.left - margin.right;
  const usableHeight = pageHeight - margin.top - margin.bottom;

  // Image dimensions
  const imgWidth = usableWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let positionY = margin.top;

  // First page
  pdf.addImage(
    imgData,
    "JPEG",
    margin.left,
    positionY,
    imgWidth,
    imgHeight,
    undefined,
    "FAST"
  );

  heightLeft -= usableHeight;

  // Additional pages
  while (heightLeft > 0) {
    pdf.addPage();

    positionY = margin.top - (imgHeight - heightLeft);

    pdf.addImage(
      imgData,
      "JPEG",
      margin.left,
      positionY,
      imgWidth,
      imgHeight,
      undefined,
      "FAST"
    );

    heightLeft -= usableHeight;
  }

  const pdfBlob = pdf.output("blob");
  onConfirm(pdfBlob);
};


  // const uploadPdfToServer = (pdfBlob: Blob) => {
  //   // Create FormData object
  //   const formData = new FormData();
  //   formData.append('file', pdfBlob, 'document.pdf'); // 'document.pdf' is the file name

  //   // Use Axios or Fetch to send it to the server
  //   axios.post('https://example.com/upload', formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //   })
  //   .then(response => {
  //     console.log('File uploaded successfully:', response.data);
  //   })
  //   .catch(error => {
  //     console.error('Error uploading the file:', error);
  //   });
  // };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Agreement Modal"
      ariaHideApp={false}
      className="agreement-modal"
    >
      <div id="pdf-content"  >

        <div className='scorll-div'>
          <div ref={contentRef}>
            <div className='term-head'>
              <h1>Standard Terms and Conditions </h1>
            </div>
            <div>
              {/* <div className='para-agreement'>
              <h3>Subscription</h3>
              <p>Lorem Ipsum is simply dummy <b>{details?.firstName} {details?.lastName}</b>text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five <b>{details?.email}</b>centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s with the release of
                Letraset sheets containing Lorem <b>{details?.school}</b> passages,and more recently with desktop publishing
                software like Aldus PageMaker including versions of Lorem Ipsum.</p>

              <h3>Where does it come from?</h3>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s with the release of
                Letraset sheets containing Lorem Ipsum passages,and more recently with desktop publishing
                software like Aldus PageMaker including versions of Lorem Ipsum.</p>

              <h3>Where does it come from?</h3>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s with the release of
                Letraset sheets containing Lorem Ipsum passages,and more recently with desktop publishing
                software like Aldus PageMaker including versions of Lorem Ipsum.</p>


              <h3>Where does it come from?</h3>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s with the release of
                Letraset sheets containing  <b>{moment().format('DD-MM-YYYY hh:mm')}</b> Lorem Ipsum passages,and more recently with desktop publishing
                software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </div> */}
              <div className='para-agreement'>

                <h2>Subscription </h2>
                <p>Grit Leadership grants a non-exclusive, limited license for use of the Grit Leadership Web Application to Client <b>{details?.plan?.title}</b>. The purpose of the Subscription is to provide resources and survey tools used to foster leadership skills and habits of leaders within the Client’s organization.</p>

                <h2>Payment Terms of Subscription</h2>
{details?.payable  && (
  (() => {
    const upgradeDetailsRaw = localStorage.getItem("upgradeDetails");

const upgradeDetails = upgradeDetailsRaw
  ? JSON.parse(upgradeDetailsRaw)
  : null;
 const shouldAddAddonPrice =
  details?.type !== "only-addons" && upgradeDetails?.onlyBuyAddon !== true;
const basePrice =
  (details?.payable || 0) +
  (shouldAddAddonPrice === true ? (details?.AlreadyAvailableAddonTotal || 0) : 0);
    const isStripe = details?.paymentMethodType === 2;
    const processingFee = isStripe ? basePrice * 0.03 : 0;  // 3% fee only for Stripe
    const total = basePrice + processingFee  ; 
    // final total

    return (
      <p>
        As consideration for the Subscription, Client agrees to pay Grit Leadership  
        <b> ${total.toFixed(2)}</b>.

        The Subscription Fee is subject to annual adjustment.
      </p>
    );
  })()
)}
{/* {details?.payable < (details?.plan?.price ?? 0) && (
  (() => {
    const basePrice = details?.payable || 0;                // base amount (without fees)
    const isStripe = details?.paymentMethodType === 2;
    const processingFee = isStripe ? basePrice * 0.03 : 0;  // 3% fee only for Stripe
    const total = basePrice + processingFee;                // final total

    return (
      <p>
        As consideration for the Subscription, Client agrees to pay Grit Leadership a <b>difference of ${basePrice.toFixed(2)} now for upgrade to plan {details?.plan?.title}
        </b>

        {isStripe && (
          <>
            , plus a 3% processing fee of 
            <b> ${processingFee.toFixed(2)}</b>
          </>
        )}

        , bringing the total to 
        <b> ${total.toFixed(2)}</b>.

“You are paying the difference to access these features now. Your subscription will still renew on at the full new plan price.”      </p>
    );
  })()
)} */}

                <p>Unless previously agreed to in writing by Grit Leadership, the Subscription Fee shall be made payable to “Grit Leadership” at 1935 Menominee, GR, MI 49506.</p>
                <p>The Subscription Fee represents the per annum sum payable to Grit Leadership for services hereunder and any other expenses incidental to the web application, unless otherwise specified in this Agreement. For reimbursable incidental expenses specified in this Agreement, original invoices or receipts will be required from Grit Leadership to Client for reimbursement.</p>
                <p>Client agrees to pay the Subscription Fee, as adjusted, annually on or before its <b>{moment.tz('America/Detroit').format('MM/DD/YYYY HH:mm:ss z')}</b> The subscription will automatically renew unless the client specifically opts out by email communication to Grit Leadership at least ten (10) calendar days prior to its Annual Payment Date. In the event Client is unable to execute evergreen or continuous agreements, Client agrees to annually execute the then-current Subscription Agreement.</p>
                <p>Balances not paid within thirty (30) calendar days of Annual Payment Date are subject to a late payment fee equal to fifteen (15%) of the outstanding balance.</p>

                <h2>Confidentiality and Nondisclosure</h2>
                <p>The parties recognize that during the term of this Agreement, Grit Leadership will provide confidential or proprietary information to the Client <b>{details.firstName} {details?.lastName}</b>. Except as may be required by applicable law, such Confidential Information shall be held in strict confidence and shall not be disclosed by Client to any unauthorized party without the prior written consent of Grit Leadership. The terms of this Agreement, including the fee, shall be treated as confidential by Client and shall not be disclosed to any third party without the prior written agreement of Grit Leadership, unless disclosure is required by law, regulation, judicial, or administrative process, or in connection with litigation pertaining hereto. Parties acknowledge and agree that Grit Leadership may modify or supplement the Confidential Information for its future use.</p>

                <h2>Limited License; Intellectual Property</h2>
                <p>Grit Leadership grants to Client a non-exclusive, non-sublicensable, and non-transferable license to use the “Grit Leadership” name and/or logo, for the purpose only of attributing the Presentation and web application to Grit Leadership and Grit Leadership in accordance with this Agreement, provided that in each case:</p>
                <ul>
                  <li>all advertising, promotional, marketing, and other material which features the above trademarks in any medium or media shall be subject to the prior review by and approval of Grit Leadership before its publication or use, and</li>
                  <li>Client shall not modify, amend, or add to the content or format of any of the trademarks in any way.</li>
                </ul>
                <p>Following the start of the Subscription to the web application, Grit Leadership permits Client to modify, amend, or add to the Confidential Information presented for Client’s sole and internal use within its own organization. NOTHING IN THIS AGREEMENT SHOULD BE INTERPRETED AS GRANTING CLIENT PERMISSION TO MODIFY, AMEND, OR ADD TO THE CONFIDENTIAL INFORMATION AND THEN DISTRIBUTE THE MODIFIED OR AMENDED CONFIDENTIAL INFORMATION TO ANY THIRD PARTY IN ANY FORM. NOTHING IN THIS AGREEMENT SHALL BE DEEMED TO VEST IN CLIENT ANY LEGAL OR BENEFICIAL RIGHT IN OR TO INTELLECTUAL PROPERTY RIGHTS OWNED OR USED UNDER LICENSE BY GRIT LEADERSHIP/GRIT LEADERSHIP OR GRANT TO CLIENT ANY RIGHT OR LICENSE TO ANY OTHER INTELLECTUAL PROPERTY RIGHTS OF GRIT LEADERSHIP/GRIT LEADERSHIP, ALL OF WHICH SHALL AT ALL TIMES REMAIN THE EXCLUSIVE PROPERTY OF GRIT LEADERSHIP. ALL INTELLECTUAL PROPERTY RIGHTS IN AND TO THE PRESENTATION AND MATERIALS RELATING TO THEM SHALL BE OWNED EXCLUSIVELY BY GRIT LEADERSHIP.</p>

                <h2>Miscellaneous</h2>
                <p>The parties acknowledge and agree that nothing in this Agreement shall imply any partnership, agency, or joint venture relationship between the parties.</p>
                <p>Time for payment shall be of the essence of the Agreement.</p>
                <p>No waiver of any provision of this Agreement shall constitute a waiver of any other provision(s) or of the same provision on another occasion.</p>
                <p>This Agreement shall be governed by and construed in accordance with the laws of the State of Michigan.</p>

                <h2>Entire Agreement</h2>
                <p>This Agreement constitutes the entire agreement between the parties and supersedes any and all understandings, whether oral or written, between the parties. No modification of this Agreement shall be effective unless set forth in a writing signed by both parties.</p>
              </div>
              <div className="modal-actions" style={{padding: "10px 10px 50px 10"}}>
                <button className='agree-btn' onClick={() => {
                  generatePDF()

                }}>I Agree</button>
                <button className='deline-btn' onClick={onDecline}>I Decline</button>
              </div>
            </div>

          </div>

        </div>
      </div>


    </Modal>
  );
};

export default AgreementModal;



// WEBPACK FOOTER //
// ./src/components/agreementModal/AgreementModal.tsx